import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import Loader from '../Loader';
import { CURRENCIES } from '../../constants/currencies';

const KCI_WEB_LOCATION_ID = '97';
const FORTY_EIGHTH_STREET_LOCATION_ID = '8';
const MIAMI_LOCATION_ID = '16';
const LOS_ANGELES_LOCATION_ID = '73';
const LONDON_LOCATION_ID = '144';
const EUROPE_LOCATION_ID = '225';
const TORONTO_LOCATION_ID = '147';
const MEXICO_CITY_LOCATION_ID = '248';
const LATAM_LOCATION_ID = '249';

class ItemList extends Component {

	constructor(props) {
		super(props);	
		this.inputRefs = [];	
		this.state = {
			//item: null,
			amount: '',
			//sku: null,
			recurrence: this.props.catalogStore.recurringByDefault ? '1' : '0',
			locationId: KCI_WEB_LOCATION_ID,
			amountInputPlaceholderText: '',
		}
	}

	handleProjectClick = (event, item) => {	
		event.preventDefault();
		const { selectedDonationItem } = this.props.catalogStore;
		const { currency } = this.props.shopStore;
		currency.set(CURRENCIES.usd);
		this.setState({
			locationId: KCI_WEB_LOCATION_ID,
			amount: ''
		})		
		if (selectedDonationItem.get() !== item) {
			selectedDonationItem.set(item);
		}
		else {
			selectedDonationItem.set(null);
		}
	}	

	handleAmountChange = event => {
		event.preventDefault();
		if (!isNaN(event.target.value)) {
			this.setState({ amount: event.target.value });
		}
	}

	handleAmountClick = (event, amount) => {
		event.preventDefault();
		this.setState({ amount: amount });		
	}

	handleOtherAmountClick = (event) => {
		event.preventDefault();
		const { selectedDonationItem } = this.props.catalogStore;
		const item = selectedDonationItem.get();		
		this.setState({ amount: '', amountInputPlaceholderText: 'Enter amount' });	
		this.inputRefs[item.id].current.focus();	
	}	

	handleRecurrenceChange = event => {
		this.setState({ recurrence: event.target.value });
	}

	handleCurrencyChange = event => {
		let { currency } = this.props.shopStore;		
		currency.set(CURRENCIES[event.target.value]);
		this.setState({
			amount: ''
		})		
	}

	handleLocationChange = event => {
		event.preventDefault();
		let { currency } = this.props.shopStore;
		this.setState({ locationId: event.target.value });		
		if (event.target.value === LONDON_LOCATION_ID) {
			currency.set(CURRENCIES.gbp)
		} else if (event.target.value === EUROPE_LOCATION_ID) {
			currency.set(CURRENCIES.eur)
		} else if (event.target.value === TORONTO_LOCATION_ID) {
			currency.set(CURRENCIES.cad)
		} else if (event.target.value === MEXICO_CITY_LOCATION_ID || 
				event.target.value === LATAM_LOCATION_ID) {
			currency.set(CURRENCIES.mxn)						
		} else {
			currency.set(CURRENCIES.usd);
		}
	}	

	handleSubmit = (event) => {	
		event.preventDefault();
		const { cartItems, recurrenceFrequency } = this.props.shopStore;
		cartItems.clear();
		recurrenceFrequency.set(null);		
		const { recurrence } = this.state;
		const { selectedDonationItem } = this.props.catalogStore;
		const item = selectedDonationItem.get();
		const cartItem = {
			id: item.id,
			sku: item.values.itemid,
			name: item.values.storedisplayname || item.values.displayname,
			price: this.state.amount,
		}
		cartItems.set(cartItem.id, cartItem);    
		if (recurrence === '1') {
			recurrenceFrequency.set(1);
		}
		this.props.shopStore.locationId = this.state.locationId;
	}	
	
	isFormValid() {
		return (this.props.catalogStore.selectedDonationItem && this.state.amount);
	}		

	componentDidMount() {
		const { catalogStore } = this.props;
		if (!catalogStore.donationItems.length) {
			catalogStore.fetchDonationItems();
		}
	}

	getCurrency() {		
		const { currency } = this.props.shopStore;		
		return currency.get();
	}

	renderAmountButton(amount) {
		return (
			<button 
				className="btn btn-outline-secondary mb-2" 
				onClick={event => this.handleAmountClick(event, amount)}
			>
				{this.getCurrency().symbol + amount}
			</button>
		);
	}

	renderOtherAmountButton() {
		return (
			<button 
				className="btn btn-secondary mb-2" 
				onClick={this.handleOtherAmountClick}
			>
				Other
			</button>
		);
	}

	renderCurrencyChooser() {
		let currencies = [];
		if ([LONDON_LOCATION_ID, EUROPE_LOCATION_ID].includes(this.state.locationId)) {
			currencies.push(CURRENCIES.gbp);
			currencies.push(CURRENCIES.eur);
			currencies.push(CURRENCIES.usd);
		} else if (this.state.locationId === TORONTO_LOCATION_ID) {
			currencies.push(CURRENCIES.cad);			
		} else if (this.state.locationId === MEXICO_CITY_LOCATION_ID ||
				this.state.locationId === LATAM_LOCATION_ID) {
			currencies.push(CURRENCIES.mxn);			
		}
		if (!currencies.length) {
			return null;
		}
		return (
			<span>
				<div className="col-sm-12">
					<label>Select currency</label>
				</div>
				<div className="col-sm-12 form-group">
					{currencies.map(cur => (		
						<div className="form-check" key={cur.code}>							
							<input 
								className="form-check-input" 
								type="radio" 
								value={cur.id} 
								checked={this.getCurrency().id === cur.id}
								onChange={this.handleCurrencyChange}
							/>
							<label className="form-check-label">
								{cur.name + ' (' + cur.code + ')'}
							</label>
						</div>		
					))}	
				</div>
			</span>
		);
	}

	renderAmountChooser(item) {
		let style = {
			overflow: 'hidden',
			transition: 'all 0.5s ease-in-out',
			maxHeight: 0,     
			opacity: 0,
		}
		const { selectedDonationItem } = this.props.catalogStore;	
		if (selectedDonationItem.get() === item) {
			style.maxHeight = '50em';
			style.opacity = 1;
		}
		this.inputRefs[item.id] = React.createRef();
		const hideAmountButtons = window.tkcWidgetContext.hideAmountButtons;
		return (
			<form 
				className="needs-validation" 
				style={style}				
				noValidate 
				onSubmit={this.handleSubmit}
			>		
				<div className="container">
					<div className="row">
						{(item.values.itemid === 'D-GNRL' || item.values.itemid === 'D-THTN' ||
								item.values.itemid === 'D-ZHPR' ||
								item.values.itemid === 'D-SPFD-WB' ||
								item.values.itemid === 'D-PURM-3' ||
								item.values.itemid === 'CAN-D-DDZKB' ||
								item.values.itemid === 'D-GIVINGTUESDAY') &&
							<div className="col-sm-12 form-group">
								{this.renderLocationSelect()}
							</div>	
						}		
						{this.renderCurrencyChooser()}														
						<div className="col-sm-12">
							<label>Choose a donation amount</label>
						</div>
						{hideAmountButtons &&
						<div className="col-sm-12 form-group">					
							{this.renderAmountButton(26.00)} &nbsp;
							{this.renderAmountButton(72.00)} &nbsp;
							{this.renderAmountButton(151.00)} &nbsp;
							{this.renderAmountButton(333.00)} &nbsp;
							{this.renderAmountButton(505.00)} &nbsp;												
							{this.renderAmountButton(720.00)} &nbsp;
							{this.renderAmountButton(1010.00)} &nbsp;													
							{this.renderAmountButton(1510.00)} &nbsp;
							{this.renderOtherAmountButton()}&nbsp;
						</div>
						}
						<div className="col-sm-6 form-group">
							<div className="input-group">
								<div className="input-group-prepend">
									<div className="input-group-text">
										{this.getCurrency().code + ' ' + this.getCurrency().symbol}
									</div>
								</div>
								<input 
									className="form-control form-control-lg"
									value={this.state.amount}
									ref={this.inputRefs[item.id]}
									placeholder={this.state.amountInputPlaceholderText}
									onChange={this.handleAmountChange}
								/>
							</div>
						</div>
						{!window.tkcWidgetContext.disableRecurringOption &&
						<div className="col-sm-6 form-group">
							<div className="form-check">
								<input 
									className="form-check-input" 
									type="radio" 
									value={0} 
									checked={this.state.recurrence === '0'}
									onChange={this.handleRecurrenceChange}
								/>
								<label className="form-check-label">
									One-time donation
								</label>
							</div>
							<div className="form-check">
								<input 
									className="form-check-input" 
									type="radio" 
									value={1} 
									checked={this.state.recurrence === '1'}
									onChange={this.handleRecurrenceChange}
								/>
								<label className="form-check-label">
									Monthly recurring donation
								</label>						
							</div>	
						</div>	
						}						
						<div className="col-sm-4 form-group">
							<button 
								type="submit" 
								className="tkc-btn btn-block tkc-btn-red" 	
								disabled={!this.isFormValid()}																					
							>
								Proceed                
							</button>					
						</div>
					</div>
				</div>
			</form>
		);
	}

	renderLocationSelect() {
		return (
			<span>
				<label>
					Select the organization to receive your donation
				</label>
				<select                   								 
					className="form-control" 
					name="location"								
					value={this.state.locationId}
					onChange={this.handleLocationChange}
				>
					<option key={KCI_WEB_LOCATION_ID} value={KCI_WEB_LOCATION_ID}>
						Kabbalah Centre International
					</option>
					<option key={FORTY_EIGHTH_STREET_LOCATION_ID} value={FORTY_EIGHTH_STREET_LOCATION_ID}>
						Kabbalah Centre New York
					</option>
					<option key={MIAMI_LOCATION_ID} value={MIAMI_LOCATION_ID}>
						Kabbalah Centre Florida
					</option>
					<option key={LOS_ANGELES_LOCATION_ID} value={LOS_ANGELES_LOCATION_ID}>
						Kabbalah Centre Los Angeles
					</option>	
					<option key={LONDON_LOCATION_ID} value={LONDON_LOCATION_ID}>
						Kabbalah Centre United Kingdom
					</option>	
					<option key={EUROPE_LOCATION_ID} value={EUROPE_LOCATION_ID}>
						Kabbalah Centre Europe
					</option>	
					<option key={TORONTO_LOCATION_ID} value={TORONTO_LOCATION_ID}>
						Kabbalah Centre Toronto
					</option>
					<option key={MEXICO_CITY_LOCATION_ID} value={MEXICO_CITY_LOCATION_ID}>
						Kabbalah Centre Mexico City
					</option>	
					<option key={LATAM_LOCATION_ID} value={LATAM_LOCATION_ID}>
						Kabbalah Centre Latin America
					</option>																																	
				</select>					
			</span>			
		);
	}

    render() {
		const { donationItems, processing, selectedDonationItem } = this.props.catalogStore;		
		return (
			<div className="container">
				<div className="row">
			  		<div className="col-md-12">
						{donationItems.length > 1 &&
							<h3>Please choose a project for your donation</h3>
						}
						{processing.get() && 
							<Loader />
						}
					</div>
					{!processing.get() &&
						donationItems.map(item => (
							<span key={item.id}>
								<div className="col-md-12">
									{donationItems.length > 1 &&
									<hr />
									}
									<a href="" onClick={e => this.handleProjectClick(e, item)}>
										<span className={(selectedDonationItem.get() === item) ? 'tkc-text-red' : ''}>
											<h5 className={(selectedDonationItem.get() === item) ? 'tkc-text-red' : ''}>
												{item.values.storedisplayname || item.values.displayname}											
											</h5>																				
											<p 
												dangerouslySetInnerHTML={{ __html: item.values.storedescription }}
												className="small"
											>										
											</p>
											{selectedDonationItem.get() !== item &&
												<p>
													<button 
														className="btn btn-sm tkc-btn-outline-red" 													
													>
														Select This Project
													</button>											
												</p>
											}																					
										</span>
									</a>
								</div>
								<div className="col-md-12">
									{this.renderAmountChooser(item)}																  
								</div>
							</span>
						))
					}					
				</div>
			</div>
		);
    }

}

export default inject('shopStore', 'catalogStore')(observer(ItemList));



// WEBPACK FOOTER //
// ./src/components/donation-catalog/ItemList.js